import React from "react";
import "../../helper.css";
import ProductItem from "./ProductItem";

const Cards = () => {
  return (
    <>
      <ProductItem />
    </>
  );
};

export default Cards;
